export default __webpack_public_path__ + "media/src/features/footer/assets/skyline-2c10831d22d4b6b0ca42ad2dda28acb3.svg";